/* eslint-disable react/display-name */
import React, { useState, forwardRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Module from './Module';
import Component from './Component/Component';
import Page from './Page/Page';
import { find, isEmpty } from 'lodash'

const ObjectListItem = props => {
  const {
    title,
    depth,
    objIndex,
    open,
    label,
    objectType,
    formState,
    setFormState,
    objectListItem,
    ...rest
  } = props;


  const rolesAccessState = useSelector(state => state.rolesAccessState);

  useEffect(() => {
    let permissions = rolesAccessState.permissionsListByRole;
    let item = find(permissions, ['object_id', objectListItem.id]);
    if(!isEmpty(item)){
      setFormState(formState => ({
        ...formState,
        values: {
          ...formState.values,
          role_access_rights: {
            ...formState.values.role_access_rights,
            [item.object_id]: {
              ...formState.values[item.object_id],
              'add': (item.rights_add == '1') ? true : false,
              'edit': (item.rights_edit == '1') ? true : false,
              'delete': (item.rights_delete == '1') ? true : false,
              'view': (item.rights_view == '1') ? true : false,
              'view_deleted': (item.rights_view_deleted == '1') ? true : false,
              'reporting_access_edit': item.reporting_access_edit,
              'reporting_access_delete': item.reporting_access_delete,
              'reporting_access_view': item.reporting_access_view,
              'object_id': item.object_id,
              'office_wise_access': (item.office_wise_access == '1') ? true : false,
              'client_wise_access': (item.client_wise_access == '1') ? true : false,
              'program_wise_access': (item.program_wise_access == '1') ? true : false,
              'client_ids': item.client_ids,
              'office_ids': item.office_ids,
              'program_ids': item.program_ids,
              'id': item.id 
            }
          }
        }
      }));
    }
    else{
      setFormState(formState => ({
        ...formState,
        values: {
          ...formState.values,
          role_access_rights:{
            ...formState.values.role_access_rights,
            [objectListItem.id]: {
              ...formState.values[objectListItem.id],
              'add': false,
              'edit': false,
              'delete': false,
              'view': false,
              'view_deleted': false,
              'reporting_access_edit': 'disabled',
              'reporting_access_delete': 'disabled',
              'reporting_access_view': 'disabled',
              'object_id': objectListItem.id,
              'office_wise_access': false,
              'client_wise_access': false,
              'client_ids': null,
              'office_ids': null,
            }
          }
        }
      }));
    }
    
  }, []);

  if (objectType === 'Page') {
    return (
      <Page
        depth={depth}
        objIndex={objIndex}
        label={label}
        open={open}
        title={title}
        objectType={objectType}
        key={objectListItem.id}
        objectListItem={objectListItem}
        setFormState={setFormState}
        formState={formState}
        {...rest}
      >
      </Page>
    );
  } else if (objectType === 'Component') {
    return (
      <>
      <Component
        depth={depth}
        objIndex={objIndex}
        label={label}
        open={open}
        title={title}
        objectType={objectType}
        key={objectListItem.id}
        objectListItem={objectListItem}
        setFormState={setFormState}
        formState={formState}
        {...rest}
      >
      </Component></>
    );
  } else {
    return (
      <Module
        depth={depth}
        objIndex={objIndex}
        label={label}
        open={open}
        title={title}
        objectType={objectType}
        key={objectListItem.id}
        objectListItem={objectListItem}
        setFormState={setFormState}
        formState={formState}
        {...rest}
      >
      </Module>
    );
  } 
};

ObjectListItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  label: PropTypes.any,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  objectType: PropTypes.string.isRequired
};


export default ObjectListItem;
